import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — on every pathname change, resets scroll to top-left for
 * both the window and any potentially scroll-capturing element. This
 * ensures every route mounts with the header visible, not somewhere in
 * the middle of the previous page's scroll position (React Router does
 * NOT restore scroll by default).
 *
 * Uses "auto" behavior (instant) instead of "smooth" so navigation
 * feels snappy — smooth scroll would visibly race up the page.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL contains an in-page anchor (e.g. `/settings#billing`),
    // let the browser handle it — don't override with a top scroll.
    if (hash) return;
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch {
      // Older browsers
      window.scrollTo(0, 0);
    }
    // Some layouts scroll a nested container instead of window (e.g. main
    // panels with their own overflow). Reset the first common scroll host.
    const main = document.querySelector("main");
    if (main && typeof main.scrollTo === "function") {
      try { main.scrollTo({ top: 0, left: 0, behavior: "auto" }); } catch { main.scrollTop = 0; }
    }
  }, [pathname, hash]);

  return null;
}
